<template>
  <div class="uploader-one van-cell calendars" v-if="uploadNumber === 2">
    <div class="uploader-label">
      <!-- <span class="showRequired">*</span>{{ label }} -->
    </div>
    <van-field :name="name" :rules="rulesRevise" :border="false">
      <template #input>
        <!-- :accept="accept" -->
        <van-uploader
          class="uploader-one-vant"
          v-model="uploader"
          :max-size="fileKB"
          :multiple="multiple"
          :disabled="disabledRate"
          :deletable="!disabledRate"
          @oversize="onOversize"
          :after-read="afterRead"
          :max-count="computedMaxCount"
          :before-delete="uploadDelete"
        />
        <div class="uploader-one-label">
          <!-- <span class="uol-name"><span v-if="requireds">*</span>{{ label }}</span> -->
          <div class="uol-examples" v-if="examplesUrl" @click="handerExamples">
            查看示例
          </div>
        </div>
      </template>
      {{ notify }}
    </van-field>
  </div>
  <div class="uploader-over van-cell calendars" v-else>
    <van-cell-group :border="false">
      <div class="uploader-label">
        <span class="showRequired" v-if="requireds">*</span>
        {{ label }}
      </div>
      <van-field :name="name" :rules="rulesRevise" :border="false">
        <!-- :accept="accept" -->
        <template #input>
          <van-uploader
            v-model="uploader"
            :max-size="fileKB"
            :multiple="true"
            :disabled="disabledRate"
            :deletable="!disabledRate"
            @oversize="onOversize"
            :after-read="afterRead"
            :max-count="computedMaxCount"
            :before-delete="uploadDelete"
          />
          <div class="uploader-one-label">
            <!-- <span class="uol-name"><span v-if="requireds">*</span>{{ label }}</span> -->
            <div class="uol-examples" v-if="examplesUrl" @click="handerExamples">
              查看示例
            </div>
          </div>
          
        </template>
      </van-field>
      <div class="uploader-label">
        {{ notify }}
      </div>
    </van-cell-group>
  </div>
</template>

<script>
import { Toast, ImagePreview } from 'vant';
import { uploadPicture, getPictureUrl, getPictureData } from '@/api/components';
import { imageFullUrl } from '@/utils/util';
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    notify: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: null
    },
    rules: {
      type: [Array, Object],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: null
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    fileSize: {
      type: Number,
      default: 2
    },
    sizeUnit: {
      type: String,
      default: 'MB'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // action: {
    //   type: String,
    //   default: ''
    // },
    readonly: {
      type: Boolean,
      default: false
    },
    uploadNumber: {
      type: Number,
      default: 1
    },
    examplesUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      pictureType: ['jpeg', 'jpg', 'png', 'jfif', 'bmp', 'tiff', 'gif', 'mp4'],
      requireds: false,
      uploader: [],
      uploaderID: [],
      fileKB: this.handFileKB(),
      disabledRate: false,
      rulesRevise: null,
      stopWarch: true
    };
  },
  computed: {
    // 是否隐藏上传按钮
    shouldHideUpload() {
      return !!(this.value && this.stopWarch);
    },
    // 动态计算max-count，当需要隐藏上传按钮时，设置为当前uploader的长度
    computedMaxCount() {
      console.log(this.shouldHideUpload,'this.shouldHideUpload')
      // 当条件满足时，返回uploader的长度（如果为0则返回0，这样上传按钮就不会显示）
      if (this.shouldHideUpload) {
        return this.uploaderID.length;
      }
      return this.uploadNumber;
    }
  },
  watch: {
    readonly: {
      handler: function() {
        if (this.readonly) {
          this.disabledRate = true;
        }
      },
      deep: true,
      immediate: true
    },
    rules: {
      handler: function() {
        if (this.rules && this.rules.length > 0 && this.rules[0].required) {
          this.rulesRevise = [{ required: true, message: this.placeholder }];
          this.requireds = true;
        }
      },
      deep: true,
      immediate: true
    },
    value: {
      handler: function() {
        if (this.value && this.stopWarch) {
          this.handerFileUrl(this.value);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //计算附件大小
    handFileKB() {
      if (this.sizeUnit === 'KB') {
        return this.fileSize * 1024;
      }
      if (this.sizeUnit === 'MB') {
        return this.fileSize * 1024 * 1024;
      }
      if (this.sizeUnit === 'GB') {
        return this.fileSize * 1024 * 1024 * 1024;
      }
    },
    // 文件超过大小提示
    onOversize(file) {
      Toast('文件大小不能超过 ' + this.fileSize + this.sizeUnit);
    },
    // 图片压缩
    compressImage(file, maxWidth = 1920, maxHeight = 1920, quality = 0.8) {
      return new Promise((resolve, reject) => {
        if (!file || !file.type || !file.type.startsWith('image/')) {
          resolve(file);
          return;
        }
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            let { width, height } = img;
            if (width > maxWidth || height > maxHeight) {
              const widthRatio = maxWidth / width;
              const heightRatio = maxHeight / height;
              const ratio = Math.min(widthRatio, heightRatio);
              width = Math.floor(width * ratio);
              height = Math.floor(height * ratio);
            }
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob(
              (blob) => {
                if (!blob) {
                  reject(new Error('图片压缩失败'));
                  return;
                }
                if (blob.size >= file.size) {
                  resolve(file);
                  return;
                }
                const compressedFile = new File([blob], file.name, {
                  type: file.type,
                  lastModified: Date.now()
                });
                resolve(compressedFile);
              },
              file.type,
              quality
            );
          };
          img.onerror = () => reject(new Error('图片加载失败'));
          img.src = event.target.result;
        };
        reader.onerror = () => reject(new Error('文件读取失败'));
        reader.readAsDataURL(file);
      });
    },
    // 文件上传
    async afterRead(file, detail) {
      console.log(file);
      this.stopWarch = false;
      const lists = Array.isArray(file) ? file : [file];
      console.log(lists);
      // let fileStream = file.content;
      // let fileName = file.file.name;
      file.status = 'uploading';
      file.message = '上传中...';
      // let suffix = fileName.split('.').pop();
      // let data = {
      //   endWith: suffix,
      //   fileType: suffix,
      //   imageString: fileStream,
      //   pictureRealName: fileName,
      //   returnFlag: false
      // };
      const formData = new FormData();
      for (const item of lists) {
        console.log(item);
        const fileLength = item.file.name.split('.');
        const fileType = fileLength[fileLength.length - 1];
        if (!this.pictureType.includes(fileType)) {
          Toast('仅支持.bmp .dib .jpg .png .gif .tif .tiff .webp .avif‌ .apng的图片');
          return;
        }
        let uploadFile = item.file;
        try {
          uploadFile = await this.compressImage(item.file);
          item.file = uploadFile;
        } catch (err) {
          console.warn('图片压缩失败，将使用原文件', err);
        }
        console.log(uploadFile);
        formData.append('file', uploadFile);
      }
      console.log(formData);
  // const data = formData.getData()
  // console.log(formData)
      uploadPicture(formData)
        .then((res) => {
          let { status, resultData } = res;
          if (status === 'complete') {
            file.status = 'success';
            file.message = '上传成功';
            file.id = resultData;
            this.uploaderID.push(resultData);
          } else {
            file.status = 'failed';
            file.message = '上传失败';
          }
          this.$emit('input', JSON.stringify(this.uploaderID));
        })
        .catch((e) => {
          file.status = 'failed';
          file.message = '上传失败';
        });
    },
    /* 解析图片url */
    async handerFileUrl(data) {
      let parsedData = JSON.parse(data);
      this.uploader = [];
      this.uploaderID = parsedData;
      parsedData.forEach(item => {
        let obj = {
          id: item.id,
          url: imageFullUrl(item.fileId),
          isImage: true
        };
        this.uploader.push(obj);
      });
      console.log(this.uploader,'this.uploader')
    },
    /* 附件删除 */
    uploadDelete(data) {
      let id = data.id;
      let index = this.uploaderID.indexOf(data.id);
      this.uploaderID.splice(index, 1);
      this.$emit('input', JSON.stringify(this.uploaderID));
      return true;
    },
    //查看示例
    handerExamples() {
      if (this.examplesUrl) {
        let data = this.examplesUrl.split(',');
        ImagePreview({
          images: data,
          closeable: true
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.uploader-one {
  width: calc(100% / 2 - 10px);
  min-width: 88px;
  float: left;
  height: 185px;
  /deep/.van-cell {
    // padding: 16px 0 0 0;
    padding: 10px 16px;
  }
  /deep/.van-field__control {
    display: flex;
    // justify-content: center;
    // flex-direction: column;
  }
  /deep/.van-uploader__upload {
    margin: 0;
  }
  /deep/.van-overlay {
    background-color: rgba(0, 0, 0, 0.9);
  }
  /deep/.van-field__error-message {
    text-align: center;
  }
  /deep/.van-uploader__preview {
    margin: 0;
  }
  /deep/.van-field__error-message {
    line-height: 18px;
  }
  .uploader-one-label {
    margin-top: 6px;
    text-align: center;
    // height: 50px;
    .uol-name {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      span {
        color: #fb5906;
      }
    }
    .uol-examples {
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #4a90e2;
    }
    .showRequired {
      color: #fb5906;
    }
  }
}
.uploader-over {
  float: left;
  width: 100%;
}
.uploader-label {
  background: #ffffff;
  padding: 10px 16px 0px 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  .showRequired {
    color: #fb5906;
  }
}
.calendars {
  padding: 0;
  flex-direction: column;
}
</style>
